class CollectionSeoDescription extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('[data-description-viewport]');
    this.content = this.querySelector('[data-description-content]');
    this.toggle = this.querySelector('[data-description-toggle]');
    this.toggleLabel = this.querySelector('[data-description-toggle-label]');

    if (!this.viewport || !this.content || !this.toggle || !this.toggleLabel) {
      return;
    }

    this.isExpanded = false;
    this.abortController = new AbortController();

    this.toggle.addEventListener('click', () => this.toggleDescription(), {
      signal: this.abortController.signal,
    });

    window.addEventListener('resize', () => this.queueUpdate(), {
      signal: this.abortController.signal,
    });

    this.resizeObserver = new ResizeObserver(() => this.queueUpdate());
    this.resizeObserver.observe(this.content);

    this.queueUpdate();
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.resizeObserver?.disconnect();
  }

  queueUpdate() {
    if (this.updateQueued) {
      return;
    }

    this.updateQueued = true;

    requestAnimationFrame(() => {
      this.updateQueued = false;
      this.updateDescription();
    });
  }

  updateDescription() {
    const contentHeight = this.content.scrollHeight;
    const collapsedHeight = this.getCollapsedHeight();
    const shouldCollapse = collapsedHeight > 0 && contentHeight > collapsedHeight + 1;

    if (!shouldCollapse) {
      this.isExpanded = false;
      this.toggle.hidden = true;
      this.toggle.setAttribute('aria-expanded', 'false');
      this.viewport.style.maxHeight = 'none';
      return;
    }

    this.toggle.hidden = false;
    this.toggle.setAttribute('aria-expanded', this.isExpanded.toString());
    this.toggleLabel.textContent = this.isExpanded ? this.toggle.dataset.showLess : this.toggle.dataset.showMore;
    this.viewport.style.maxHeight = `${this.isExpanded ? contentHeight : collapsedHeight}px`;
  }

  getCollapsedHeight() {
    const firstParagraph = this.content.querySelector('p');
    const firstContentElement = firstParagraph || this.content.firstElementChild;

    if (!firstContentElement) {
      return this.content.scrollHeight;
    }

    const contentRect = this.content.getBoundingClientRect();
    const firstContentRect = firstContentElement.getBoundingClientRect();

    return Math.ceil(firstContentRect.bottom - contentRect.top);
  }

  toggleDescription() {
    this.isExpanded = !this.isExpanded;
    this.updateDescription();
  }
}

if (!window.customElements.get('collection-seo-description')) {
  window.customElements.define('collection-seo-description', CollectionSeoDescription);
}
